import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconShare$1 = /*@__PURE__*/ proxyCustomElement(class WppIconShare extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-share", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15 3.45837C14.1486 3.45837 13.4584 4.1486 13.4584 5.00004C13.4584 5.85148 14.1486 6.54171 15 6.54171C15.8515 6.54171 16.5417 5.85148 16.5417 5.00004C16.5417 4.1486 15.8515 3.45837 15 3.45837ZM11.9584 5.00004C11.9584 3.32017 13.3202 1.95837 15 1.95837C16.6799 1.95837 18.0417 3.32017 18.0417 5.00004C18.0417 6.67991 16.6799 8.04171 15 8.04171C14.0806 8.04171 13.2565 7.6338 12.6988 6.98908L7.97257 9.35219C8.01785 9.56096 8.04171 9.77771 8.04171 10C8.04171 10.2223 8.01787 10.439 7.9726 10.6477L12.6989 13.0109C13.2566 12.3662 14.0807 11.9584 15 11.9584C16.6799 11.9584 18.0417 13.3202 18.0417 15C18.0417 16.6799 16.6799 18.0417 15 18.0417C13.3202 18.0417 11.9584 16.6799 11.9584 15C11.9584 14.7777 11.9822 14.561 12.0275 14.3522L7.30127 11.9891C6.74353 12.6338 5.91942 13.0417 5.00004 13.0417C3.32017 13.0417 1.95837 11.6799 1.95837 10C1.95837 8.32017 3.32017 6.95837 5.00004 6.95837C5.91936 6.95837 6.74342 7.36622 7.30116 8.01085L12.0275 5.64769C11.9822 5.43899 11.9584 5.2223 11.9584 5.00004ZM5.00004 8.45837C4.1486 8.45837 3.45837 9.1486 3.45837 10C3.45837 10.8515 4.1486 11.5417 5.00004 11.5417C5.85148 11.5417 6.54171 10.8515 6.54171 10C6.54171 9.1486 5.85148 8.45837 5.00004 8.45837ZM13.4584 15C13.4584 14.1486 14.1486 13.4584 15 13.4584C15.8515 13.4584 16.5417 14.1486 16.5417 15C16.5417 15.8515 15.8515 16.5417 15 16.5417C14.1486 16.5417 13.4584 15.8515 13.4584 15Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-share-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-share", "wpp-icon-share-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-share-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-share-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconShare$1);
      }
      break;
  } });
}

const WppIconShare = WppIconShare$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconShare, defineCustomElement };
